import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyDVbBVWYyKu96x8sDIT1UgI4Q2iSP18JZ8",
    authDomain: "koku-my.firebaseapp.com",
    projectId: "koku-my",
    storageBucket: "koku-my.firebasestorage.app",
    messagingSenderId: "52241010837",
    appId: "1:52241010837:web:b8f3a52da1387ef7c9cb9c",
    measurementId: "G-Q2QDECF1WS"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };